module.exports = __webpack_public_path__ + "media/images/emblems/Gland-coat_of_arms-9097144decbb646c476a79c1e35f79ae.svg";